module.exports = __webpack_public_path__ + "static/Compu2-f15e0a694b673d937ca7d185f4848859.png";